/** Backend ContextEnum.UserPanel */
export const USER_PANEL_CONTEXT = 1;

export const GROUP_NAME_MAX_LENGTH_API = 32;

export const IMPORT_CONTACT_LIMIT = 10_000;

export const SYSTEM_EXCEL_COLUMNS = {
  FirstName: 'FirstName',
  LastName: 'LastName',
  Mobile: 'Mobile',
  Email: 'Email',
  Gender: 'Gender',
  Address: 'Address',
} as const;

export type SystemExcelColumn = (typeof SYSTEM_EXCEL_COLUMNS)[keyof typeof SYSTEM_EXCEL_COLUMNS];
